import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Tooltip, Progress } from 'antd';
import { getSummary } from 'ACTIONS/reports.actions';
import './Summary.less';

class Summary extends Component {
  componentDidMount() {
    this.props.getSummary();
  }
  render() {
    const { summary = {} } = this.props;
    const {
      isLoaded = false,
      statuses = {},
    } = summary;

    if (!isLoaded) {
      return (
        <div className="summary">
          Loading the latest reports...
        </div>
      );
    }

    const total = Object.keys(statuses).reduce((sum, next) => sum + statuses[next], 0);
    const { sent, problem } = statuses;

    const percent = Math.round(((sent + problem) / total) * 100);
    const successPercent = (sent / total) * 100;
    const todo = total - (sent + problem);

    if (isLoaded && !total) {
      return null;
    }

    return (
      <div className="summary">
        <Tooltip placement="topLeft" title={`${sent} Sent / ${problem} Problem / ${todo} Not Sent`}>
          <Progress percent={percent} successPercent={successPercent} status={sent ? null : 'exception'} />
        </Tooltip>
      </div>
    );
  }
}

Summary.defaultProps = {
  summary: {
    statuses: {
      save: 0,
      paused: 0,
      schedule: 0,
      sending: 0,
      sent: 0,
      problem: 0,
      skipped: 0,
    },
    isLoaded: false,
  },
};

Summary.propTypes = {
  getSummary: PropTypes.func.isRequired,
  summary: PropTypes.shape({
    statuses: PropTypes.shape({
      save: PropTypes.number,
      paused: PropTypes.number,
      schedule: PropTypes.number,
      sending: PropTypes.number,
      sent: PropTypes.number,
      problem: PropTypes.number,
      skipped: PropTypes.number,
    }),
    isLoaded: PropTypes.bool,
  }),
};

const mapStateToProps = ({ reports }) => ({
  summary: reports.summary,
});

export default connect(mapStateToProps, { getSummary })(Summary);



// WEBPACK FOOTER //
// ./src/pages/Reports/Summary/Summary.js